var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { FontSizeData_fontType } from './decoration_fontsize.enums';
export function fontSizeData_fontTypeFromJSON(object) {
    switch (object) {
        case 0:
        case 'PX':
            return FontSizeData_fontType.PX;
        case 1:
        case 'EM':
            return FontSizeData_fontType.EM;
        case -1:
        case 'UNRECOGNIZED':
        default:
            return FontSizeData_fontType.UNRECOGNIZED;
    }
}
export function fontSizeData_fontTypeToJSON(object) {
    switch (object) {
        case FontSizeData_fontType.PX:
            return 'PX';
        case FontSizeData_fontType.EM:
            return 'EM';
        default:
            return 'UNKNOWN';
    }
}
var baseFontSizeData = { unit: FontSizeData_fontType.PX };
export var FontSizeData = {
    fromJSON: function (object) {
        var message = __assign({}, baseFontSizeData);
        if (object.unit !== undefined && object.unit !== null) {
            message.unit = fontSizeData_fontTypeFromJSON(object.unit);
        }
        else {
            message.unit = FontSizeData_fontType.PX;
        }
        if (object.value !== undefined && object.value !== null) {
            message.value = Number(object.value);
        }
        else {
            message.value = undefined;
        }
        return message;
    },
    toJSON: function (message) {
        var obj = {};
        message.unit !== undefined && (obj.unit = fontSizeData_fontTypeToJSON(message.unit));
        message.value !== undefined && (obj.value = message.value);
        return obj;
    },
};
//# sourceMappingURL=decoration_fontsize.js.map